import React from 'react';
import { Check } from 'lucide-react';

const SocialProof = () => {
  const improvements = [
    'Decision quality improves',
    'Accountability improves',
    'Governance risk reduces',
    'Board performance improves',
    'Stakeholder confidence increases',
    'Governance becomes a strategic advantage',
  ];

  return (
    <section id="social-proof" className="py-24 md:py-32 px-6 border-y border-ink/5 bg-white/40 backdrop-blur-sm relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-lime/5 via-transparent to-transparent opacity-50"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 text-ink">
            When governance <span className="highlighter">improves.</span>
          </h2>
          <p className="text-lg md:text-xl text-ink/60 leading-relaxed font-medium">
            GovernWell helps organisations move from uncertainty to clarity through a
            structured governance improvement process.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {improvements.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white border border-ink/5 rounded-2xl p-6 shadow-saas-sm hover:shadow-md transition-shadow group"
            >
              <div className="w-8 h-8 rounded-full bg-lime flex items-center justify-center shrink-0 mt-0.5 group-hover:scale-110 transition-transform shadow-sm">
                <Check className="w-4 h-4 text-ink" strokeWidth={3} />
              </div>
              <span className="font-semibold text-lg text-ink/80 leading-snug">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
